export const globalFiltersBlankSlates = (
  <svg width="100%" height="100%" viewBox="0 0 329 514" fill="none">
    <rect
      x=".5"
      y=".5"
      width="328"
      height="513"
      rx="7.5"
      fill="#fff"
      stroke="#E6E6E6"
    />
    <rect
      x="16.5"
      y="17.5"
      width="296"
      height="38"
      rx="3.5"
      fill="#fff"
      stroke="#D6D5D5"
    />
    <rect
      x="16.5"
      y="17.5"
      width="296"
      height="39"
      rx="3.5"
      fill="#fff"
      stroke="#D6D5D5"
    />
    <g clipPath="url(#bkac5wp9va)">
      <path
        d="m43.54 43.395-3.838-3.859a6.17 6.17 0 0 0 1.521-3.907 6.153 6.153 0 0 0-1.344-3.967 6.53 6.53 0 0 0-3.617-2.28 6.714 6.714 0 0 0-4.298.41 6.41 6.41 0 0 0-3.086 2.92 6.103 6.103 0 0 0-.515 4.145 6.266 6.266 0 0 0 2.282 3.544 6.65 6.65 0 0 0 4.074 1.383 6.596 6.596 0 0 0 3.73-1.138l3.867 3.887a.848.848 0 0 0 .6.269.876.876 0 0 0 .618-.23.82.82 0 0 0 .26-.586.798.798 0 0 0-.254-.59v-.001zm-8.82-12.556c.951 0 1.881.273 2.673.784a4.689 4.689 0 0 1 1.772 2.087c.364.85.46 1.786.274 2.688a4.605 4.605 0 0 1-1.317 2.382 4.865 4.865 0 0 1-2.464 1.273 4.966 4.966 0 0 1-2.78-.265 4.78 4.78 0 0 1-2.16-1.713 4.542 4.542 0 0 1-.81-2.584c0-1.234.506-2.417 1.409-3.29a4.898 4.898 0 0 1 3.402-1.362z"
        fill="#BCBDC3"
        stroke="#BCBDC3"
        strokeWidth=".5"
      />
    </g>
    <path
      d="M60.016 39.96c0 1.006-.365 1.79-1.094 2.352-.73.563-1.719.844-2.969.844-1.354 0-2.396-.174-3.125-.523v-1.281c.469.198.98.354 1.531.468a8.055 8.055 0 0 0 1.641.172c.885 0 1.552-.166 2-.5.448-.338.672-.807.672-1.406 0-.396-.08-.719-.242-.969-.157-.255-.422-.49-.797-.703-.37-.214-.935-.456-1.696-.727-1.062-.38-1.822-.83-2.28-1.351-.454-.52-.68-1.2-.68-2.04 0-.88.33-1.58.992-2.1.661-.521 1.536-.782 2.625-.782 1.135 0 2.18.208 3.133.625l-.414 1.156c-.943-.395-1.86-.593-2.75-.593-.704 0-1.253.15-1.649.453-.396.302-.594.721-.594 1.258 0 .395.073.72.22.976.145.25.39.482.733.695.35.209.88.44 1.594.696 1.198.427 2.021.885 2.469 1.375.453.49.68 1.125.68 1.906zm5.757 3.196c-1.265 0-2.265-.385-3-1.156-.729-.77-1.093-1.841-1.093-3.21 0-1.381.338-2.477 1.015-3.29.683-.813 1.597-1.219 2.742-1.219 1.073 0 1.922.354 2.547 1.063.625.703.938 1.633.938 2.789v.82h-5.899c.026 1.005.28 1.768.758 2.29.485.52 1.164.78 2.04.78.921 0 1.833-.192 2.734-.578v1.157a6.627 6.627 0 0 1-1.305.421 7.04 7.04 0 0 1-1.477.133zm-.351-7.789c-.688 0-1.237.224-1.649.672-.406.448-.645 1.068-.718 1.86h4.476c0-.818-.182-1.443-.547-1.876-.364-.437-.885-.656-1.562-.656zM76.406 43l-.258-1.219h-.062c-.427.537-.854.901-1.281 1.094-.422.188-.95.281-1.586.281-.85 0-1.516-.218-2-.656-.48-.438-.719-1.06-.719-1.867 0-1.73 1.383-2.636 4.148-2.719l1.454-.047v-.531c0-.672-.146-1.167-.438-1.484-.286-.323-.747-.485-1.383-.485-.713 0-1.52.219-2.422.656l-.398-.992c.422-.229.883-.409 1.383-.539a6.052 6.052 0 0 1 1.515-.195c1.021 0 1.776.226 2.266.68.495.453.742 1.18.742 2.18V43h-.96zm-2.93-.914c.808 0 1.44-.221 1.899-.664.463-.443.695-1.063.695-1.86v-.773l-1.297.055c-1.03.036-1.776.198-2.234.484-.453.281-.68.721-.68 1.32 0 .47.141.826.422 1.07.287.245.685.368 1.196.368zm10.477-7.805c.38 0 .721.032 1.024.094l-.18 1.203a4.42 4.42 0 0 0-.938-.117c-.692 0-1.286.281-1.78.844-.49.562-.735 1.263-.735 2.101V43h-1.297v-8.563h1.07l.149 1.586h.062c.318-.557.7-.987 1.149-1.289.447-.302.94-.453 1.476-.453zM90 43.156c-1.24 0-2.2-.38-2.883-1.14-.677-.766-1.015-1.847-1.015-3.243 0-1.432.343-2.539 1.03-3.32.694-.781 1.678-1.172 2.954-1.172.411 0 .823.044 1.234.133.412.089.735.193.97.313l-.4 1.101a5.818 5.818 0 0 0-.937-.281 4.055 4.055 0 0 0-.898-.117c-1.74 0-2.61 1.11-2.61 3.328 0 1.052.211 1.86.633 2.422.427.562 1.057.843 1.89.843.714 0 1.446-.153 2.196-.46v1.148c-.573.297-1.294.445-2.164.445zM100.062 43v-5.54c0-.697-.158-1.218-.476-1.562-.318-.343-.815-.515-1.492-.515-.901 0-1.56.245-1.977.734-.411.49-.617 1.292-.617 2.406V43h-1.297V30.844H95.5v3.68c0 .442-.02.81-.063 1.101h.079a2.624 2.624 0 0 1 1.086-.969c.474-.24 1.013-.36 1.617-.36 1.047 0 1.83.25 2.351.75.526.496.789 1.285.789 2.368V43h-1.297z"
      fill="#BCBDC3"
    />
    <rect x="16" y="77" width="16" height="16" rx="8" fill="#F6F6F6" />
    <path fill="#fff" d="M34 69h263v32H34z" />
    <rect x="46" y="77" width="239" height="16" rx="8" fill="#F6F6F6" />
    <rect x="16" y="113" width="16" height="16" rx="8" fill="#F6F6F6" />
    <path fill="#fff" d="M34 105h263v32H34z" />
    <rect x="46" y="113" width="239" height="16" rx="8" fill="#F6F6F6" />
    <rect x="16" y="149" width="16" height="16" rx="8" fill="#F6F6F6" />
    <path fill="#fff" d="M34 141h263v32H34z" />
    <rect x="46" y="149" width="239" height="16" rx="8" fill="#F6F6F6" />
    <rect x="16" y="185" width="16" height="16" rx="8" fill="#F6F6F6" />
    <path fill="#fff" d="M34 177h263v32H34z" />
    <rect x="46" y="185" width="239" height="16" rx="8" fill="#F6F6F6" />
    <rect x="16" y="221" width="16" height="16" rx="8" fill="#F6F6F6" />
    <path fill="#fff" d="M34 213h263v32H34z" />
    <rect x="46" y="221" width="239" height="16" rx="8" fill="#F6F6F6" />
    <rect x="16" y="257" width="16" height="16" rx="8" fill="#F6F6F6" />
    <path fill="#fff" d="M34 249h263v32H34z" />
    <rect x="46" y="257" width="239" height="16" rx="8" fill="#F6F6F6" />
    <rect x="16" y="293" width="16" height="16" rx="8" fill="#F6F6F6" />
    <path fill="#fff" d="M34 285h263v32H34z" />
    <rect x="46" y="293" width="239" height="16" rx="8" fill="#F6F6F6" />
    <rect x="16" y="329" width="16" height="16" rx="8" fill="#F6F6F6" />
    <path fill="#fff" d="M34 321h263v32H34z" />
    <rect x="46" y="329" width="239" height="16" rx="8" fill="#F6F6F6" />
    <rect x="16" y="365" width="16" height="16" rx="8" fill="#F6F6F6" />
    <path fill="#fff" d="M34 357h263v32H34z" />
    <rect x="46" y="365" width="239" height="16" rx="8" fill="#F6F6F6" />
    <rect x="16" y="401" width="16" height="16" rx="8" fill="#F6F6F6" />
    <path fill="#fff" d="M34 393h263v32H34z" />
    <rect x="46" y="401" width="239" height="16" rx="8" fill="#F6F6F6" />
    <rect x="16" y="437" width="16" height="16" rx="8" fill="#F6F6F6" />
    <path fill="#fff" d="M34 429h263v32H34z" />
    <rect x="46" y="437" width="239" height="16" rx="8" fill="#F6F6F6" />
    <rect x="16" y="473" width="16" height="16" rx="8" fill="#F6F6F6" />
    <path fill="#fff" d="M34 465h263v32H34z" />
    <rect x="46" y="473" width="239" height="16" rx="8" fill="#F6F6F6" />
    <defs>
      <clipPath id="bkac5wp9va">
        <path fill="#fff" transform="translate(28 29)" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
